import type { DropTargetOptions } from '@affine/component';
import type { AffineDNDData } from '@affine/core/types/dnd';

import type { NavigationPanelTreeNodeDropEffect } from '../../tree';

/**
 * Only folders and docs can become templates, so those are the only entities
 * the templates section accepts.
 */
export const templatesRootCanDrop: DropTargetOptions<AffineDNDData>['canDrop'] =
  data => {
    const type = data.source.data.entity?.type;
    return type === 'folder' || type === 'doc';
  };

export const templatesRootDropEffect: NavigationPanelTreeNodeDropEffect =
  data => {
    const type = data.source.data.entity?.type;
    return type === 'folder' || type === 'doc' ? 'link' : undefined;
  };
